module.exports = __webpack_public_path__ + "static/media/banner_aboutus-03Contact_us.6dd1135d.png";